import { Dialog, type DialogProps } from '../Dialog/Dialog';

/**
 * The sheet shape on every viewport. Use it for surfaces that are conceptually
 * "attached to the bottom" on any screen - a mobile nav drawer, a row action
 * list - and plain `Dialog` (variant `auto`) for content that should become a
 * centred dialog on a desktop.
 */
export type BottomSheetProps = Omit<DialogProps, 'variant'>;

export function BottomSheet(props: BottomSheetProps) {
  return <Dialog {...props} variant="sheet" />;
}
